import React from "react";
import Dialog from "@material-ui/core/Dialog";

const SignInDialog = ({ onClose, src, isTablet }) => {
  const handleClose = (event, reason) => {
    // Prevent closing on backdrop click or escape key press when isTablet is true
    if (isTablet && (reason === "backdropClick" || reason === "escapeKeyDown")) {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={Boolean(src)}
      onClose={isTablet ? handleClose : onClose}
      maxWidth="sm"
      fullWidth
    >
      <iframe
        src={src}
        title="My Best User Sign In"
        style={{ border: "none", minHeight: "70vh" }}
        allow="publickey-credentials-get *; publickey-credentials-create *"
      />
    </Dialog>
  );
};

export default SignInDialog;
